import { httpsCallable } from 'firebase/functions';
import * as XLSX from 'xlsx';
import { functions } from '../firebase_config';

interface EncryptedExportRequest {
  fileName: string;
  contentBase64: string;
}

interface EncryptedExportResponse {
  fileName: string;
  contentBase64: string;
}

const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let binary = '';

  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    const chunk = Array.from(bytes.subarray(offset, offset + chunkSize));
    binary += String.fromCharCode.apply(null, chunk);
  }

  return btoa(binary);
};

const base64ToBlob = (base64: string): Blob => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return new Blob([bytes], { type: 'application/zip' });
};

const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

export const downloadEncryptedExcel = async (
  rows: Record<string, unknown>[],
  sheetName: string,
  fileBaseName: string
): Promise<void> => {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const workbookBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  }) as ArrayBuffer;
  const date = new Date().toISOString().split('T')[0];
  const fileName = `${fileBaseName}_${date}.xlsx`;

  const createEncryptedExport = httpsCallable<EncryptedExportRequest, EncryptedExportResponse>(
    functions,
    'createEncryptedExport'
  );
  const result = await createEncryptedExport({
    fileName,
    contentBase64: arrayBufferToBase64(workbookBuffer),
  });

  downloadBlob(base64ToBlob(result.data.contentBase64), result.data.fileName);
};
